import { render, staticRenderFns } from "./ShowAdress.vue?vue&type=template&id=16fdf095&"
import script from "./ShowAdress.vue?vue&type=script&lang=js&"
export * from "./ShowAdress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports